
import axios from 'axios'

export const getMerchant = async(organizationId, programId, merchantId) => {
    if (!merchantId) return { name: '', pivot: { cost_to_program: 1, redemption_value: 1 } };

    if (String(merchantId).startsWith('gcm-')) {
        const gcmId = String(merchantId).replace(/^gcm-/, '');
        // Always ask the API: it serves the Yelp business from the backend cache and the
        // description / redemption instructions fresh from the GCM parent merchant, which a
        // business cached here would hold stale. The cached copy is only the fallback.
        try {
            const res = await axios.get(`/gcm/business/${gcmId}`);
            const biz = res.data;
            sessionStorage.setItem(`gcm_business_${gcmId}`, JSON.stringify(biz));
            return { ...biz, pivot: { cost_to_program: 1, redemption_value: 1 }, is_gcm: true };
        } catch (e) {
            let cached = null;
            try { cached = JSON.parse(sessionStorage.getItem(`gcm_business_${gcmId}`)); } catch (_) {}
            if (cached) {
                return { ...cached, pivot: { cost_to_program: 1, redemption_value: cached.sku_value ?? 1 }, is_gcm: true };
            }
            return { name: 'Local Merchant', pivot: { cost_to_program: 1, redemption_value: 1 }, is_gcm: true };
        }
    }

    const response = await axios.get(`/organization/${organizationId}/program/${programId}/merchant/${merchantId}`)
    return response.data
}